import React, { useEffect, useState } from 'react';
import { DataTable } from '@uhg-abyss/web/ui/DataTable';
import { useSelector } from 'react-redux';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useDataTable } from '@uhg-abyss/web/hooks/useDataTable';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol/IconSymbol';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { event } from '@uhg-abyss/web/tools/event';
import { Link } from '@uhg-abyss/web/ui/Link';
import PropTypes from 'prop-types';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { LagoonContext } from '@src/AppContext';
import apiData from './OrganizationListReviewUrl.json';
import 'regenerator-runtime/runtime';
import { constants } from '@src/common/Utils/Constants';
import HealthCheckMapping from './HealthCheckMapping.json';

const Wrapper = styled('div', {});

const AccordianLinks = styled('div', {
  display: 'grid',
});

const ApiStatusStyles = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '2px 8px',
  gap: '8px',

  '@screen >= $xs': {
    padding: '10px',
  },

  '@screen >= $sm': {
    padding: '10px',
  },
});

const ApiCategoryStyles = styled('div', {
  width: '100%',
});

const DisplayFlex = styled('div', {
  display: 'flex',
});

const IconPadding = styled('div', {
  marginTop: '2px',
  paddingRight: '10px',
  marginLeft: '2px',
});

const UpdatedDate = styled('p', {
  color: '#424242',
  fontSize: '$sm',
  fontWeight: '$normal',
  minHeight: '20px',
  lineHeight: '20px',
  display: 'flex',
  marginBottom: '0px',
});

const StyledLink = styled(Link, {});

const AccordianLink = styled('div', {});

export const OrganizationList = ({ orgUserInfo }) => {
  const [date, setDate] = useState('');
  const healthCheckApiData = useSelector((state) => {
    return state.GET_API_HEALTH_CHECK;
  });
  const healthCheckData = healthCheckApiData?.data;
  const { navigate } = useRouter();
  const lagoonContext = React.useContext(LagoonContext);
  const configs = lagoonContext?.getTable('configs');
  const orgViewPageSize = configs?.getRow('ORG_VIEW_PAGE_SIZE');
  const featureToggles = lagoonContext?.getTable('feature-toggles');
  const providerDemoToggle = featureToggles?.getRow(
    'PROVIDER_DEMOGRAPHIC_TOGGLE'
  )?.enabled;
  const trackitToggle = featureToggles?.getRow('TRACKIT_TOGGLE')?.enabled;

  const getApiEnvironment = (row) => {
    return (
      <Wrapper>
        {row.includes('Production') && (
          <ApiStatusStyles>{row[1]}</ApiStatusStyles>
        )}
        {row.includes('Staging') && <ApiStatusStyles>{row[0]}</ApiStatusStyles>}
      </Wrapper>
    );
  };

  const columns = [
    {
      Header: <span style={{ fontSize: '13px' }}>Product Name</span>,
      accessor: 'apiCategory',
    },
    {
      Header: <span style={{ fontSize: '13px' }}>Environment</span>,
      accessor: 'environment',
    },
    {
      Header: <span style={{ fontSize: '13px' }}>Status</span>,
      accessor: 'status',
    },
  ];

  const getApiCategory = (row) => {
    const apiInfo = apiData && apiData[row?.replace(/\s+/g, '').toLowerCase()];
    const interactionName = apiInfo?.name;
    const interactionContext = 'product link clicks';
    const feedbackRoute = `/welcome/${row
      ?.replace(/\s+/g, '')
      ?.toLowerCase()}-feedback`;
    const getReviewApi = (apiLink) => {
      const interactionValue = 'review api';
      event('INTERACTION_EVENT', {
        interactionName,
        interactionValue,
        interactionContext,
      });
      navigate(apiLink);
    };
    const getReleaseNote = (releaseNoteLink) => {
      const interactionValue = 'release notes';
      event('INTERACTION_EVENT', {
        interactionName,
        interactionValue,
        interactionContext,
      });
      navigate(releaseNoteLink);
    };
    const getFeedBackPage = () => {
      const interactionValue = 'api feedback';
      event('INTERACTION_EVENT', {
        interactionName,
        interactionValue,
        interactionContext,
      });
      navigate(feedbackRoute);
    };
    return (
      <ApiCategoryStyles>
        <Accordion
          type="multiple"
          style={{
            backgroundColor: 'inherit',
            width: '100%',
          }}
        >
          <Accordion.Item value={apiInfo?.name}>
            <Accordion.Trigger
              style={{
                backgroundColor: 'inherit',
                fontWeight: 'bold',
                borderBottom: 0,
                fontSize: '14px',
              }}
            >
              {apiInfo?.serviceName === 'Superconnector'
                ? `Super Connector  ${apiInfo?.name}`
                : apiInfo?.name}
            </Accordion.Trigger>
            <Accordion.Content style={{ backgroundColor: 'inherit' }}>
              <AccordianLinks>
                <AccordianLink>
                  <StyledLink
                    size="13px"
                    fontWeight="$normal"
                    onClick={() => {
                      return getReviewApi(apiInfo?.technicalDetailsPage);
                    }}
                  >
                    Review API
                  </StyledLink>
                </AccordianLink>
                <AccordianLink>
                  <StyledLink
                    size="13px"
                    fontWeight="$normal"
                    onClick={() => {
                      return getFeedBackPage();
                    }}
                  >
                    API Feedback
                  </StyledLink>
                </AccordianLink>
                {apiInfo?.releaseNotesPage && (
                  <AccordianLink>
                    <StyledLink
                      size="13px"
                      fontWeight="$normal"
                      onClick={() => {
                        return getReleaseNote(apiInfo?.releaseNotesPage);
                      }}
                    >
                      Release Notes
                    </StyledLink>
                  </AccordianLink>
                )}
              </AccordianLinks>
            </Accordion.Content>
          </Accordion.Item>
        </Accordion>
      </ApiCategoryStyles>
    );
  };

  const getSortedDataList = (data) => {
    if (data) {
      const apiSortedData = [...data];
      return apiSortedData?.sort((a, b) => {
        return a.localeCompare(b);
      });
    }
    return [];
  };

  let stageList = providerDemoToggle
    ? orgUserInfo.linkedApis?.stage
    : orgUserInfo.linkedApis?.stage.filter((item) => {
        return item !== 'ProviderDemographic';
      });
  stageList = trackitToggle
    ? stageList
    : stageList.filter((item) => {
        return item !== 'TrackIt';
      });
  const stageApiList = getSortedDataList(stageList);

  const getApiStatus = (item, row) => {
    const api = HealthCheckMapping[item] || item;
    let stageColor = 'neutral';
    let stageStatusValue = 'Fetching status';
    if (healthCheckData?.stage?.[api] != null) {
      stageColor = healthCheckData?.stage[api] === 200 ? 'success' : 'error';
      stageStatusValue = stageColor === 'success' ? 'Operational' : 'Outage';
    }

    let prodColor = 'neutral';
    let prodStatusValue = 'Fetching status';
    if (healthCheckData?.prod?.[api] != null) {
      prodColor = healthCheckData?.prod[api] === 200 ? 'success' : 'error';
      prodStatusValue = prodColor === 'success' ? 'Operational' : 'Outage';
    }

    // The following APIs are super connectors and their operational status is hardcoded to 'Operational'
    // because still the helthcheck need to implement for these apis, once implemented we can remove this condition.

    const SUPER_CONNECTOR_APIS = [
      'Member Eligibility Check',
      'Claim Precheck',
      'Claim Actions',
      'Claim Status Inquiry',
      'Benefits Check',
      'Prior Auth And Referral Actions',
    ];
    if (SUPER_CONNECTOR_APIS.includes(item)) {
      prodColor = 'success';
      stageColor = 'success';
      stageStatusValue = 'Operational';
      prodStatusValue = 'Operational';
    }

    if (healthCheckApiData?.error) {
      stageColor = 'warning';
      stageStatusValue = 'Not available';
      prodColor = 'warning';
      prodStatusValue = 'Not available';
    }

    return (
      <Wrapper>
        {row.includes('Production') && (
          <ApiStatusStyles>
            <Badge
              rounded
              variant={prodColor}
              css={{
                'abyss-badge-content': {
                  fontSize: '13px !important',
                },
              }}
            >
              {prodStatusValue}
            </Badge>
          </ApiStatusStyles>
        )}
        {row.includes('Staging') && (
          <ApiStatusStyles>
            <Badge
              rounded
              variant={stageColor}
              css={{
                'abyss-badge-content': {
                  fontSize: '13px !important',
                },
              }}
            >
              {stageStatusValue}
            </Badge>
          </ApiStatusStyles>
        )}
      </Wrapper>
    );
  };

  const dataList =
    stageApiList.length > 0
      ? stageApiList.map((item) => {
          const status = ['Staging'];
          const prodList = orgUserInfo.linkedApis?.prod;
          if (prodList?.includes(item)) {
            status.push('Production');
          }
          const data = {
            apiCategory: getApiCategory(item),
            environment: getApiEnvironment(status),
            status: getApiStatus(item, status),
          };
          return data;
        })
      : [];

  const lastUpdatedText = () => {
    return (
      <DisplayFlex>
        <IconPadding>
          <IconSymbol icon="update" size={16} />
        </IconPadding>
        <UpdatedDate style={{ fontSize: '13px' }}>
          last updated {date}
        </UpdatedDate>
      </DisplayFlex>
    );
  };

  const dataTableProps = useDataTable({
    showPagination: true,
    initialData: dataList,
    initialColumns: columns,
    pageSizeDefault: orgViewPageSize?.value || 10,
    showTopPagination: false,
    additionalPaginationText: lastUpdatedText(),
  });

  useEffect(() => {
    dataTableProps.setData(dataList);

    setDate(healthCheckApiData?.lastUpdatedDate);
  }, [healthCheckApiData]);

  return (
    <Wrapper>
      <DataTable
        title={
          <span style={{ fontSize: '19px' }}>Your Organization's APIs</span>
        }
        tableState={dataTableProps}
        css={{
          '.abyss-data-table-pagination-top-root': {
            display: 'none !important',
          },
          '.abyss-data-table-pagination-bottom-root': {
            marginTop: constants.IMPORTANT_TAG_ZERO,
            paddingTop: 'var(--space-sm) !important',
            paddingBottom: 'var(--space-sm) !important',
            backgroundColor: 'white !important',
            borderBottomRightRadius: '4 !important',
            borderBottomLeftRadius: '4 !important',
          },
          '.abyss-table-td': {
            padding: constants.IMPORTANT_TAG_ZERO,
          },
          '.abyss-accordion-root': {
            border: 'none !important',
          },
          '.abyss-table-cell': {
            padding: constants.IMPORTANT_TAG_ZERO,
            fontSize: '13px !important',
          },
        }}
      />
    </Wrapper>
  );
};

OrganizationList.propTypes = {
  orgUserInfo: PropTypes.shape({
    linkedApis: PropTypes.shape({
      stage: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
};
